if (!customElements.get('quick-add')) {
class QuickAdd extends HTMLElement {    
    constructor() {
        super();
        // Get quick add btton
        this.quickAddButton = this.querySelector('#quick-add');
        this.domParser = new DOMParser();

        // check or create quick view wrapper
        if(document.querySelectorAll('.quick-add-wrap').length == 0){
            this.quickViewWrapper = document.createElement('div');
            this.quickViewWrapper.classList.add('quick-add-wrap');
            this.quickViewWrapperOverlay = document.createElement('div');
            this.quickViewWrapperOverlay.classList.add('quick-add-overlay');
            document.querySelector('body').appendChild(this.quickViewWrapper);
            document.querySelector('body').appendChild(this.quickViewWrapperOverlay);
        }
        
        this.productUrl = this.getAttribute('data-product-url');
        this.quickViewWrapper = document.querySelector('.quick-add-wrap');
        this.quickViewWrapperOverlay = document.querySelector('.quick-add-overlay');
        if (this.quickAddButton) {
            if(this.quickAddButton.dataset.onlyVariant){
                this.addEventListener('click', (event) => this.addProduct(event));
            }
            else{
                this.quickAddButton.addEventListener('click', (event) => this.openQuickViewModal(event));
            }
        }
    }
    async openQuickViewModal(event) {
        this.quickAddButton.classList.add('loading')
        const url = this.productUrl;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const html = await response.text();
            const newContent = this.domParser.parseFromString(html, 'text/html');
            const productData = newContent.querySelector('div.main-product');
            productData.querySelector('.media').remove();
            this.quickAddButton.classList.remove('loading');
            if (productData) {
                
                const newScriptTag = document.createElement('script');
                newScriptTag.setAttribute('src', productData.getAttribute('data-form-script'));
                this.quickViewWrapper.appendChild(newScriptTag);
                const closeButton = document.createElement('button');
                this.quickViewWrapperOverlay.classList.add('visible');
                this.quickViewWrapper.classList.add('visible');
                closeButton.classList.add('close-quick-view');
                closeButton.innerHTML = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 8.8125L21.1875 7.5L15 13.6875L8.8125 7.5L7.5 8.8125L13.6875 15L7.5 21.1875L8.8125 22.5L15 16.3125L21.1875 22.5L22.5 21.1875L16.3125 15L22.5 8.8125Z" fill="black"/></svg>`;
                this.quickViewWrapper.innerHTML = productData.outerHTML;
                this.quickViewWrapper.appendChild(closeButton);
                closeButton.addEventListener('click', () => {
                    this.quickViewWrapperOverlay.classList.remove('visible');
                    this.quickViewWrapper.classList.remove('visible');
                });

                this.quickViewWrapperOverlay.addEventListener('click', () => {
                    this.quickViewWrapperOverlay.classList.remove('visible');
                    this.quickViewWrapper.classList.remove('visible');
                });
            }
        } catch (error) {
            this.quickAddButton.classList.add('loading')
            console.error('Error:', error);
        }
    }
    async addProduct(event){
        this.quickAddButton.classList.add('loading')
        const variantId = this.quickAddButton.dataset.onlyVariant;
        const quantity = 1;
        const formData = {
            'id': variantId,
            'quantity': quantity
        };
        fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(formData),
          })
          .then(function (data) {
            return data.json();
          })
          .then((response) => {
            const url = document.querySelector('.section-mini-cart').id.replace('shopify-section-','');
            fetch(`${Shopify.routes.root}?section_id=${url}`)
            .then(res=>res.text())
            .then(data=>{
                  const footerCart = this.domParser.parseFromString(data, 'text/html').querySelector(`.section-mini-cart .min-cart-footer`);
                  document.querySelector(`.section-mini-cart .min-cart-footer`).innerHTML = footerCart.innerHTML;
                  const htmlCard = this.domParser.parseFromString(data, 'text/html').querySelector(`.section-mini-cart .cart-items-list`);
                  document.querySelector(`.section-mini-cart .cart-items-list`).innerHTML = htmlCard.innerHTML;
                  const itemsCount = this.domParser.parseFromString(data, 'text/html').querySelectorAll(`.section-mini-cart cart-item`);
                  this.quickAddButton.classList.remove('loading')

                  if(itemsCount.length > 0){
                    document.querySelector(`.section-mini-cart div.min-cart-footer`).style.display="flex";
                    document.querySelector('.mini-cart-bubble').textContent = htmlCard.getAttribute('data-count');
                  }
                  else{
                    document.querySelector('.mini-cart-bubble').textContent = '0'
                  }
                  if(response.status === 422) {
                    const existingErrorElement = document.querySelector('.main-product-quantity-wrapper p.error-message');
                    if(existingErrorElement) return;
                    const errorElement = document.createElement('p');
                    errorElement.classList.add('error-message');
                    errorElement.innerHTML = response.description;
                    document.querySelector('.main-product-quantity-wrapper').appendChild(errorElement);
                    return;
                  }
                  document.querySelector('[href="/cart"]').click();
                  document.querySelector('input.quantity__input').value = 1
            }) 
            .catch(error=>{
                this.quickAddButton.classList.remove('loading');
                console.log('Error:', error)
            })
        });
    }
    
}
customElements.define('quick-add', QuickAdd);
}
